import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { UserState } from './types';

const selectUser = (app: StoreState): UserState => app.user;

export const getUserLoading = createSelector(
  selectUser,
  (user: UserState): UserState['loading'] => user.loading
);

export const getUserRightsLoading = createSelector(
  selectUser,
  (user: UserState): UserState['rightsLoading'] => user.rightsLoading
);

export const getUserHistoryLoading = createSelector(
  selectUser,
  (user: UserState): UserState['historyLoading'] => user.historyLoading
);

export const getUserError = createSelector(
  selectUser,
  (user: UserState): UserState['error'] => user.error
);

export const getUserMembers = createSelector(
  selectUser,
  (user: UserState): UserState['members'] => user.members
);

export const getUserHistory = createSelector(
  selectUser,
  (user: UserState): UserState['loginDetails'] => user.loginDetails
);

export const getUserRights = createSelector(
  selectUser,
  (user: UserState): UserState['userRights'] => user.userRights
);

export const selectUserAdvancedUserRights = createSelector(
  selectUser,
  (user: UserState): UserState['advancedUserRights'] => user.advancedUserRights
);
